module.exports = __webpack_public_path__ + "img/content_info2.7cbecd5d.jpg";